export const rolePermissionColumns = [
  {
    field: "name",
    headerName: "Grupo",
    flex: 1,
    minWidth: 150,
  },
];
